import { defineStore } from 'pinia';
import { useLocalStorage } from '@vueuse/core';

export const useGameProgressStore = defineStore('gameProgress', () => {
  // Persistent state
  const tickets = useLocalStorage('gameProgress.tickets', 0);
  const completed_plays = useLocalStorage('gameProgress.completed_plays', 0);
  const gamesPlayed = useLocalStorage('gameProgress.gamesPlayed', 0);

  function updateTickets(amount: number) {
    tickets.value += amount;
  }

  function setTickets(amount: number) {
    tickets.value = amount;
  }

  function incrementCompletedPlays() {
    completed_plays.value++;
    gamesPlayed.value++;
  }

  function setCompletedPlays(count: number) {
    completed_plays.value = count;
    gamesPlayed.value = count; // Keep these in sync
  }

  function resetProgress() {
    tickets.value = 0;
    completed_plays.value = 0;
    gamesPlayed.value = 0;
  }

  return {
    // State
    tickets,
    completed_plays,
    gamesPlayed,

    // Actions
    updateTickets,
    setTickets,
    incrementCompletedPlays,
    setCompletedPlays,
    resetProgress,
  };
});
